import BreadcrumbItem from './src/breadcrumb-item';

BreadcrumbItem.install = function(Vue) {
  Vue.component(BreadcrumbItem.name, BreadcrumbItem);
};

export default BreadcrumbItem;



// WEBPACK FOOTER //
// ./src/components/breadcrumb-item/index.js